<template>
    <transition name="fade">
        <div class="page" ref="page">
            <!-- <img src="/img/xj/rabbit.gif" alt="" class="rabbit"> -->
            <div class="rabbit"></div>
            <div
                class="glass"
                ref="glass"
                :style="{backgroundSize: `${clientWidth}px ${clientHeight}px`}">
            </div>
            <span class="text" v-if="find"></span>
            <div class="box">
                <span class="goon" v-if="find&&show" @click="goOn">继续</span>
                <div :class="['introduce', {find: !find}]" ref="introduce1">
                    <div class="scroll1"></div>
                </div>
                <div :class="['introduce', {find: find}]" ref="introduce2">
                    <div class="scroll2"></div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import BScroll from 'better-scroll';

export default {
    data() {
        return {
            clientWidth: 1080,
            clientHeight: 1920,
            rem: 100,
            fontText: ['欲入画中境，必先', '过此关。', '', '宋画之中，常有', '"隐款"现象，即画', '作之中，并无醒目', '款识。', '', '请你用放大镜观察', '画作，寻找范宽', '"隐款"。'],
            endText: ['范宽，北宋画家，', '名中正，字中立，', '陕西华原（今耀', '县）人。', '', '性情疏野，襟抱超', '然，嗜酒好道，不', '拘世俗。擅画山', '水，被称为"北宋', '三大家"之一。', '', '范宽师承李成、荆', '浩，后师造化，久', '居终南、太华，得', '山之骨，与山传', '神，自成一派。', '', '画风沉郁苍莽，善', '用"雨点皴"及"积墨', '法"，绘"云烟惨', '淡、风月阴霁难状', '之景"，呈山峦浑厚', '势壮雄强之感。'],
            find: false,
            show: true,
            timer: null,
            bsScroll1: null,
            bsScroll2: null
        };
    },
    methods: {
        showText() {
            this.show = true;
        },
        mousedown(e) {
            const client = e.touches[0];
            const disX = client.clientX - this.$refs.glass.offsetLeft;
            const disY = client.clientY - this.$refs.glass.offsetTop;
            document.body.ontouchmove = event => {
                clearTimeout(this.timer);
                const c = event.touches[0];
                let l = c.clientX - disX <= 0 ? 0 : c.clientX - disX;
                let t = c.clientY - disY <= 0 ? 0 : c.clientY - disY;
                if (t >= this.clientHeight - 2 * this.rem) {
                    t = this.clientHeight - 2 * this.rem;
                }
                if (l >= this.clientWidth - 2 * this.rem) {
                    l = this.clientWidth - 2 * this.rem;
                }
                this.$refs.glass.style.top = `${t}px`;
                this.$refs.glass.style.left = `${l}px`;
                this.$refs.glass.style.backgroundPosition = `-${l}px -${t}px`;
                if (
                    Math.abs(t - 8 * this.rem) < this.rem
                    && Math.abs(l - 6 * this.rem) < this.rem
                ) {
                    this.timer = setTimeout(() => {
                        this.find = true;
                        this.show = false;
                        this.destoryEvent();
                        setTimeout(() => {
                            this.showText();
                        }, 1500);
                    }, 300);
                }
            };
        },
        mouseup() {
            document.body.ontouchmove = null;
        },
        goOn() {
            this.bsScroll1.destroy();
            this.bsScroll2.destroy();
            this.destoryEvent();
            this.$emit('next', 3);
        },
        back() {
            this.destoryEvent();
            this.$emit('back');
        },
        destoryEvent() {
            this.$refs.glass.removeEventListener('touchstart', this.mousedown);
            document.body.ontouchmove = null;
            document.body.removeEventListener('touchend', this.mouseup);
        }
    },
    mounted() {
        this.clientWidth = document.documentElement.clientWidth;
        this.clientHeight = document.documentElement.clientHeight;
        this.rem = 100 * (this.clientWidth / 1080);
        this.$refs.glass.addEventListener('touchstart', this.mousedown);
        document.body.addEventListener('touchend', this.mouseup);
        this.bsScroll1 = new BScroll(this.$refs.introduce1, {
            probeType: 3,
            scrollY: false,
            scrollX: true,
            startX: -2000,
            bounceTime: 200,
            swipeTime: 1500,
            deceleration: 0.003,
            swipeBounceTime: 200,
            useTransition: false
        });
        this.bsScroll2 = new BScroll(this.$refs.introduce2, {
            probeType: 3,
            scrollY: false,
            scrollX: true,
            startX: -2000,
            bounceTime: 200,
            swipeTime: 1500,
            deceleration: 0.003,
            swipeBounceTime: 200,
            useTransition: false
        });
    }
};
</script>

<style lang="stylus" scoped>
@keyframes rabbit
    from
        background-position-y 0%
    to
        background-position-y 100%
.page
    background url('/img/xj/leve1.png') no-repeat
    background-size 100% 100%
    background-position center center
    .rabbit
        position absolute
        size 7.5rem 1.04rem
        background url('/img/xj/rabbit.png') no-repeat
        background-size 100% auto
        background-position-x 0
        animation rabbit 5s steps(27, end) infinite
        transform scale(1.2) translateX(8%)
        bottom 29%
        left 0
    .glass
        position absolute
        top 1rem
        left 1rem
        size 2rem
        background url('/img/xj/leve1.png') -1rem -1rem no-repeat
        transform scale(1.4)
        border .03rem solid #fff
        border-radius 50%
    .text
        size 1.04rem 4.58rem
        position absolute
        top 3.27rem
        left 5.5rem
        transform translate(0, 0) scale(0)
        animation scaleShow 3s cubic-bezier(0.55, 0.085, 0.68, 0.53)
        animation-fill-mode forwards
        background  url('/img/xj/chenfankuanzhi.png') 0 0/100% 100% no-repeat
    .box
        position absolute
        left 50%
        bottom .2rem
        size 7.14rem 3.38rem
        background-color #ede1c2
        opacity 0.78
        transform translate3d(-50%,0,1px)
        .back
            position absolute
            top -1rem
            left 0
            font-size .46rem
            color #fbecc2
        .goon
            position absolute
            top -1rem
            right 0
            font-size .46rem
            color #fbecc2
        .introduce
            position absolute
            left 50%
            top 50%
            transform translate3d(-50%, -50%, 1px)
            size 6.54rem 3.04rem
            padding .12rem 0
            border solid .02rem #5d2c1f
            background-color #ede1c2
            font-size .32rem
            color #303030
            overflow hidden
            opacity 0
            &.find
                opacity 0.78
                z-index 2
            .scroll1
                size 6.75rem 2.8rem
                background url('/img/xj/lv2_text_1.png') center center/auto 100% no-repeat
            .scroll2
                size 13.4rem 2.8rem
                background url('/img/xj/lv2_text_2.png') 0 0/auto 100% no-repeat
</style>
